export default {"src":"/_next/static/media/minus.892090b8.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};